import FilterRow from "./FilterRow"
import MaterialTableComponent from "./MaterialTable"

export * from "./material-table-helpers"
export const MaterialTable = MaterialTableComponent
export const MaterialTableFilterRow = FilterRow
